import styled from 'styled-components'

const badgeSize = {
  card: {
    width: '107px',
    height: '18px',
  },
  DA: {
    width: '119px',
    height: '20px',
  },
}

export const Stamp = styled.div`
  background-image: url(/assets/img/webp/megafeirao/mega-feirao.webp?v=202407);
  background-repeat: no-repeat;
  background-size: 100%;
  width: ${props => badgeSize[props.variation].width};
  height: ${props => badgeSize[props.variation].height};
`
